import { ChatWindow } from '@chatbot/whitelabel-chatbot-react-frontend';
import '@chatbot/whitelabel-chatbot-react-frontend/dist/style.css';
function App() {
	return <ChatWindow />;
}

export default App;
